import { render, staticRenderFns } from "./TwoPageIcon.vue?vue&type=template&id=996975c2"
import script from "./TwoPageIcon.vue?vue&type=script&lang=ts"
export * from "./TwoPageIcon.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports